import AppStoreBadge from '@/assets/icons/app-store-badge-current-color.svg?react'
import GooglePlayBadge from '@/assets/icons/google-play-badge-current-color.svg?react'
import { analytics } from '@/features/analytics/events'
import { URLS } from '@/pages/urls'
import { Trans } from '@lingui/react/macro'

const STORE_LINK_CLASS =
  'bg-black-to-white text-white-to-black flex items-center justify-center rounded-xl border border-gray-100 max-mobile:h-10 max-mobile:flex-1 max-mobile:rounded-lg max-mobile:p-0'

/**
 *
 * The card is a `section` region named by its orange headline, holding the Google Play and
 * App Store links. The card itself is not a link,
 * since a link nested inside a link is invalid HTML. The store labels are plain English,
 * like the badges' own wordmarks.
 *
 * Below 900px (`max-mobile`) the card goes full width: the art strip takes the wider
 * aspect, the white headline lines run on as one sentence and the store buttons sit side
 * by side. Tablet width keeps the desktop card, since the design has no tablet frame.
 *
 * The art strip is one exported PNG on a black ground in both themes; the card itself
 * follows the theme, with the design's gradient only in dark.
 */
export const BuzzPromoCard = () => {
  return (
    <section
      data-testid="hive-calls-promo"
      className="bg-black-to-white max-mobile:self-center max-mobile:w-full max-mobile:max-w-[350px] max-mobile:dark:bg-[linear-gradient(154deg,#141414_0%,#000_100%)] flex w-[230px] shrink-0 flex-col overflow-hidden rounded-2xl border border-gray-100 dark:bg-[linear-gradient(143deg,#141414_0%,#000_100%)]"
    >
      <div className="max-mobile:aspect-[349/194] aspect-[230/128] w-full border-b border-gray-100 bg-black">
        <img
          className="h-full w-full object-cover"
          src="/images/hive-calls-art-strip@2x.png"
          srcSet="/images/hive-calls-art-strip@2x.png 2x, /images/hive-calls-art-strip@3x.png 3x"
          alt=""
        />
      </div>
      <div className="max-mobile:pt-[23px] flex flex-col items-center gap-4 px-3.5 pt-5 pb-6">
        <p className="max-mobile:w-full max-mobile:max-w-[306px] max-mobile:text-[24px]/[1.2] w-[190px] text-center text-[22px]/[1.2] font-semibold tracking-[-0.02em]">
          <span className="text-orange block">
            <Trans>Meet Hive Calls!</Trans>
          </span>
          <span className="text-white-to-black max-mobile:inline block">
            <Trans>Talk, connect,</Trans>
          </span>{' '}
          <span className="text-white-to-black max-mobile:inline block">
            <Trans>and earn rewards.</Trans>
          </span>
        </p>
        <div className="max-mobile:w-full max-mobile:flex-row flex w-[190px] flex-col gap-3">
          <a
            href={URLS.HIVE_CALLS_ANDROID_APP}
            target="_blank"
            rel="noreferrer"
            aria-label="Get it on Google Play"
            onClick={() => analytics.hiveCallsPromoStoreClick('sidebar', 'google_play')}
            className={`${STORE_LINK_CLASS} py-[7px]`}
          >
            <GooglePlayBadge aria-hidden="true" className="max-mobile:h-7 h-9 w-auto" />
          </a>
          <a
            href={URLS.HIVE_CALLS_IOS_APP}
            target="_blank"
            rel="noreferrer"
            aria-label="Download on the App Store"
            onClick={() => analytics.hiveCallsPromoStoreClick('sidebar', 'app_store')}
            className={`${STORE_LINK_CLASS} px-4 pt-[11px] pb-2`}
          >
            <AppStoreBadge aria-hidden="true" className="max-mobile:h-[25px] h-[35px] w-auto" />
          </a>
        </div>
      </div>
    </section>
  )
}
